<template>
    <i :class="classArray"/>
</template>

<script>
import IconNames from './IconNames';
    export default {
        name:  'Icon',
        props: {
            name: {
                type: String,
                required: true,
                validator (value) {
                    if (value) {
                        // Value passed should be in the list
                        return IconNames.indexOf(value) !== -1;
                    }
                    return false;
                }
            },
            size: {
              type: String,
              required: false,
              validator(value) {
                  // La valeur passée doit être l'une de ces chaines de caractères
                  return ['mini', 'small', 'medium', 'large'].indexOf(value) !== -1;
              }
            },
            color: {
              type: String,
              required: false,
              validator(value) {
                return ['primary', 'news', 'info', 'success', 'warning', 'error'].indexOf(value) !== -1;
              },
            },
            outlined: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            classArray() {
                if (IconNames.indexOf(this.name) !== -1) {
                    return [`eui-a-icon-${this.name}`, this.size ? `-${this.size}` : '', this.color ? `-${this.color}`: '', this.outlined ? `-outlined`: ''];
                }
                throw new Error(`Icon component invalid props value: Icon ${this.name} doesn't exist`);
            }
        },
    };
</script>
